module.exports = __webpack_public_path__ + "img/c00_buildingtechlaminararmor_Normal_ua.112d023b.webp";